// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inActiveModal__yL6u_ {
  height: 464px;
  width: 372px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.modalBody__VXMV9 {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  height: 100%;
  padding: 35px 51px 0;
}

.modalBodyTitle__Hd0Hs {
  color: var(--header-title-main);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 20px;
}

.modalBodyText__KQQhm {
  font-size: 16px;
  line-height: 21px;
  color: var(--tables-secondary-row-sub-title-text);
  text-align: center;
}

.modalFooter__ob8Gk {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 30px;
  padding: 0 51px 35px;
}

.textCenter__W6MC9 {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/InactiveEquipmentModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,OAAA;EACA,YAAA;EACA,oBAAA;AAzEF;;AA4EA;EAzBE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EAsBA,kBAAA;EACA,mBAAA;AApEF;;AAuEA;EACE,eAAA;EACA,iBAAA;EACA,iDAAA;EACA,kBAAA;AApEF;;AAuEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AApEF;;AAuEA;EACE,kBAAA;AApEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.inActiveModal {\n  height: 464px;\n  width: 372px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.modalBody {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n  height: 100%;\n  padding: 35px 51px 0;\n}\n\n.modalBodyTitle {\n  @include modalTitle;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.modalBodyText {\n  font-size: 16px;\n  line-height: 21px;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-align: center;\n}\n\n.modalFooter {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 30px;\n  padding: 0 51px 35px;\n}\n\n.textCenter {\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inActiveModal": `inActiveModal__yL6u_`,
	"modalBody": `modalBody__VXMV9`,
	"modalBodyTitle": `modalBodyTitle__Hd0Hs`,
	"modalBodyText": `modalBodyText__KQQhm`,
	"modalFooter": `modalFooter__ob8Gk`,
	"textCenter": `textCenter__W6MC9`
};
module.exports = ___CSS_LOADER_EXPORT___;
